import { BaseYcState, RegisterYCState } from '@yourcause/common/state';
import { SpellCheckCorrectionForUi } from '../../form-builder.typing';
import { FormDefinitionComponent } from '@features/configure-forms/form.typing';

@RegisterYCState()
export class FormSuggestionsState extends BaseYcState {
  readonly formSuggestions: SpellCheckCorrectionForUi[];
  readonly flyoutIsOpen: boolean;
  readonly selectedComponent: FormDefinitionComponent;
}
